<template>
    <div :class="{ 'header-transparent-with-topbar': data.headerTransparency }">

        <!-- Start Header Area -->
        <header
            :class="[`rn-header header-default header-not-transparent header-sticky ${data.headerClass}`]">
            <div class="container">
                <div class="row align-items-center row--0">
                    <template v-if="data.navAlignment === 'right'">
                        <div class="col-lg-1 col-md-4 col-4">
                            <Logo />
                        </div>
                        <div class="col-lg-11 col-md-8 col-8 position-static">
                            <div class="header-right" @mousemove="mousemove()" @mouseout="mouseout()">
                                <nav class="mainmenu-nav d-none d-lg-block">
                                    <Nav />
                                </nav>
                                <div class="header-btn d-none d-lg-block" @click="orderShow">
                                    <a :class="data.buyButtonClass" href="#">
                                        预约演示
                                    </a>
                                </div>
                                <div class="mobile-menu-bar ml--5 d-block d-lg-none">
                                    <div class="hamberger">
                                        <button class="hamberger-button"
                                            @click.prevent="AppFunctions.toggleClass('.popup-mobile-menu', 'active')">
                                            <Icon name="menu" size="21" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </header>
        <MobileMenu />
        <!-- End Mobile Menu -->
        <div class="order-show" v-if="shows">
            <order-show @close="close"></order-show>
        </div>
        <!-- Start Theme Style -->
        <div>
            <div class="rn-gradient-circle" />
            <div class="rn-gradient-circle theme-pink" />
        </div>
        <!-- End Theme Style -->
    </div>
</template>
<style lang="scss">
.order-show {
    z-index: 999;
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: rgba($color: #999, $alpha: 0.9);
}
</style>
<script>
import Icon from '../../icon/Icon'
import MobileMenu from './MobileMenu'
import AppFunctions from '../../../helpers/AppFunctions'
import Nav from './NewNav'
import Logo from '../../elements/logo/Logo'
import OrderShow from '../dialog/orderShow.vue'
export default {
    name: 'Header',
    props: {
        data: {
            default: null
        }
    },
    components: { Logo, Nav, MobileMenu, Icon, OrderShow },
    data() {
        return {
            AppFunctions,
            shows: false
        }
    },
    methods: {

        mousemove(){
              const scrolled = document.documentElement.scrollTop;
            if (document.querySelector('.header-default').style.background !== '#fff' && this.$route.name == 'Home' && scrolled <= 100) {
                document.querySelector('.header-default').style.background = '#fff';
            }
        },
        mouseout(){
              const scrolled = document.documentElement.scrollTop;
            if (this.$route.name == 'Home' && scrolled <= 100) {
                document.querySelector('.header-default').style.backgroundColor = 'transparent';
            }
        },
        toggleStickyHeader() {
            const scrolled = document.documentElement.scrollTop;
            if (scrolled > 100) {
                AppFunctions.addClass('.header-default', 'sticky');
            } else if (scrolled <= 100) {
                AppFunctions.removeClass('.header-default', 'sticky');
                if (this.$route.name != 'Home') {
                    AppFunctions.addClass('.header-default', 'sticky');
                }
            }
        },
        orderShow() {
            console.log(1111);
            this.shows = true
        },
        close(){
            this.shows = false
        }
    },
    created() {
        window.addEventListener('scroll', this.toggleStickyHeader);
    },
    mounted() {
        // this.AppFunctions.toggleClass('body', 'active-light-mode')
        this.toggleStickyHeader();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.toggleStickyHeader);
    }
}
</script>